import { NON_DIGITS_REGEX } from '../regex';
import { INVALID, VALID } from './constants';
var BANK_ACCOUNT_MIN_LENGTH = 10;
var BANK_ACCOUNT_MAX_LENGTH = 10;
var BANK_CLEARING_MIN_LENGTH = 4;
var BANK_CLEARING_MAX_LENGTH = 4;
var parseClearingNumber = function parseClearingNumber(clearingNumber) {
  var result = {
    bank: null,
    valid: INVALID
  };
  var sanitized = clearingNumber.replace(NON_DIGITS_REGEX, '');
  if (sanitized.length < BANK_CLEARING_MIN_LENGTH || sanitized.length > BANK_CLEARING_MAX_LENGTH) {
    return result;
  }
  result.clearingNumber = clearingNumber;
  result.valid = VALID;
  return result;
};
var parse = function parse(bankAccount) {
  var result = {
    accountNumber: '',
    clearingNumber: '',
    bankAccount: '',
    valid: INVALID,
    formatted: '',
    error: {
      type: 'genericError',
      message: "Invalid bank account: ".concat(bankAccount)
    }
  };
  var sanitized = bankAccount.replace(NON_DIGITS_REGEX, '');
  var clearingNumber = sanitized.substr(0, 4);
  var _parseClearingNumber = parseClearingNumber(clearingNumber),
    valid = _parseClearingNumber.valid;
  if (valid === INVALID) {
    return result;
  }
  var accountNumber = sanitized.replace(clearingNumber, '');
  if (accountNumber.length < BANK_ACCOUNT_MIN_LENGTH || accountNumber.length > BANK_ACCOUNT_MAX_LENGTH) {
    return result;
  }
  result.clearingNumber = clearingNumber;
  result.accountNumber = accountNumber;
  result.bankAccount = sanitized;
  result.valid = VALID;
  result.error.type = null;
  result.error.message = null;
  return result;
};
export default parse;